import { render } from "./WaitingPeriod.vue?vue&type=template&id=27898e32&scoped=true"
import script from "./WaitingPeriod.vue?vue&type=script&lang=js"
export * from "./WaitingPeriod.vue?vue&type=script&lang=js"

import "./WaitingPeriod.vue?vue&type=style&index=0&id=27898e32&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27898e32"]])

export default __exports__